export enum ShipmentEntryIndicator {
  SECTION_321 = 'SECTION_321',
}
